import { createFrontendModule } from '@backstage/frontend-plugin-api';
import kubernetesPlugin from '@backstage/plugin-kubernetes/alpha';
import { Icon } from '@iconify/react';
import {
  isServiceEntity,
  isWebsiteEntity,
} from '@ipen-portal/ipen-entity-model';
import { and, or, showMonitoring } from '@ipen-portal/plugin-common';

export const KubernetesPlugin = createFrontendModule({
  extensions: [
    kubernetesPlugin
      .getExtension('entity-content:kubernetes/kubernetes')
      .override({
        params: {
          filter: and(showMonitoring, or(isServiceEntity, isWebsiteEntity)),
          icon: <Icon icon="simple-icons:kubernetes" />,
          loader: async () =>
            import('@backstage/plugin-kubernetes').then(m => (
              <m.Router refreshIntervalMs={30_000} />
            )),
        },
      }),
  ],
  pluginId: 'kubernetes',
});
